module.exports = __webpack_public_path__ + "static/media/filter-gender-women.eb98cb4e.svg";